var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.536596 12.3504C0.53601 14.4509 1.08899 16.5018 2.14049 18.3096L0.436035 24.4861L6.80473 22.8288C8.56624 23.7805 10.5399 24.2792 12.5455 24.2794H12.5507C19.1716 24.2794 24.5612 18.9322 24.564 12.3598C24.5653 9.175 23.3168 6.18023 21.0484 3.92713C18.7804 1.67423 15.7641 0.43285 12.5502 0.431396C5.92859 0.431396 0.539427 5.7783 0.536693 12.3504",
    fill: "url(#paint0_linear_111_7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.107395 12.3465C0.106712 14.5226 0.679516 16.6469 1.7685 18.5194L0.00292969 24.9173L6.59999 23.2006C8.41769 24.1842 10.4642 24.7028 12.5467 24.7036H12.5521C19.4105 24.7036 24.9937 19.1641 24.9966 12.3564C24.9978 9.05717 23.7043 5.95475 21.3549 3.62093C19.0052 1.2874 15.881 0.00135659 12.5521 0C5.6925 0 0.110129 5.53876 0.107395 12.3465ZM4.03618 18.1969L3.78986 17.8088C2.75438 16.1747 2.20784 14.2863 2.20862 12.3473C2.21077 6.68886 6.85061 2.08527 12.556 2.08527C15.319 2.08643 17.9156 3.15543 19.8686 5.09496C21.8215 7.03469 22.8961 9.61318 22.8955 12.3556C22.8929 18.0141 18.253 22.6182 12.5521 22.6182H12.548C10.6917 22.6172 8.87119 22.1225 7.2835 21.1875L6.90567 20.9651L2.99084 21.9838L4.03618 18.1969Z",
    fill: "url(#paint1_linear_111_7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44206 7.18489C9.20911 6.67103 8.96395 6.66066 8.74243 6.65165C8.56103 6.6439 8.35366 6.64448 8.14649 6.64448C7.93912 6.64448 7.60219 6.7219 7.3174 7.03053C7.03232 7.33944 6.229 8.08595 6.229 9.60427C6.229 11.1226 7.34327 12.59 7.4986 12.7961C7.65413 13.0018 9.64972 16.2173 12.8102 17.4544C15.4369 18.4824 15.9715 18.2779 16.5415 18.2264C17.1117 18.175 18.3813 17.48 18.6403 16.7594C18.8995 16.0389 18.8995 15.4212 18.8218 15.2922C18.7441 15.1636 18.5367 15.0863 18.2258 14.9321C17.9148 14.7778 16.386 14.0311 16.101 13.9281C15.8159 13.8252 15.6087 13.7738 15.4013 14.0829C15.1939 14.3914 14.5985 15.0863 14.417 15.2922C14.2357 15.4985 14.0542 15.5241 13.7433 15.3698C13.4322 15.2149 12.4307 14.8894 11.2427 13.8382C10.3183 13.0202 9.69424 12.01 9.51284 11.701C9.33144 11.3924 9.49341 11.2252 9.64933 11.0714C9.78904 10.9331 9.96038 10.7111 10.116 10.5309C10.271 10.3507 10.3228 10.2221 10.4265 10.0163C10.5303 9.81027 10.4783 9.63004 10.4007 9.47568C10.3228 9.32132 9.71855 7.79506 9.44206 7.18489Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_111_7",
    x1: 1206.83,
    y1: 2405.91,
    x2: 1206.83,
    y2: 0.431396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_111_7",
    x1: 1249.69,
    y1: 2491.73,
    x2: 1249.69,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.8eaf2199cdfb5114e7e2b770e8f46711.svg";
export { ForwardRef as ReactComponent };